export const PHOTO_SESSION_RESCHEDULE_CONFIRM_CLICKED = 'PHOTO_SESSION_RESCHEDULE_CONFIRM_CLICKED';
export const PHOTO_SESSION_RESCHEDULE_SUCCESS_VIEWED = 'PHOTO_SESSION_RESCHEDULE_SUCCESS_VIEWED';
